import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { CloseSidenav, EditData, NewBulkOperation, OpenSidenav } from '../actions/side-nav.actions';
import { SideNavState } from '../models/bulk.models';

const initialState: SideNavState = {
  sidenavStatus: false,
  newBulkOperation: true,
};

export const SideNavReducer = createReducer(
  initialState,
  on(OpenSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
  })),
  on(CloseSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    sidenavStatus: false,
    newBulkOperation: true,
  })),
  on(EditData, (state) => ({
    ...state,
    newBulkOperation: false,
  })),
  on(NewBulkOperation, (state) => ({
    ...state,
    newBulkOperation: true,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
